<template>
  <section v-if="hasStation" class="section-wrapp">
    <Breadcrumbs v-bind:parameters="breadcrumbsData"></Breadcrumbs>
    <section class="section-graph">
      <div class="container-fluid new-main-page-margins">
        <div class="row">
          <PowerRate></PowerRate>
          <InvertersRadar></InvertersRadar>
          <Lines></Lines>
        </div>
        <div class="row">
          <div
            :class="
              hasCamera
                ? 'col-md-7 col-lg-8 col-xl-9 order-xl-1 graph-xl-col-1'
                : 'col-md-12 col-lg-12 col-xl-12 order-xl-1 graph-xl-col-1'
            "
          >
            <div class="style graph-and-filters" style="max-width: 100%">
              <PowerAndInsolation></PowerAndInsolation>
            </div>
          </div>
          <Photo v-if="hasCamera"></Photo>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="graph-and-filters">
              <div class="row">
                <div class="col-12">
                  <PowerCalendar></PowerCalendar>
                </div>
                <div class="col-12">
                  <div class="style graph-and-filters" style="max-width: 100%">
                    <ProductionAndInsolation></ProductionAndInsolation>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="row">-->
        <!--          <div class="col-12 main-page-table-new-margin">-->
        <!--            <InvertersTable></InvertersTable>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </section>
  </section>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import "@/assets/css/custom-scrollbar.scss";
import PowerRate from "@/components/station-view/PowerRate";
import InvertersRadar from "@/components/station-view/InvertersRadar";
import PowerAndInsolation from "@/components/station-view/PowerAndInsolation";
import Photo from "@/components/station-view/Photo";
import PowerCalendar from "@/components/station-view/ProductionCalendar";
// import InvertersTable from '@/components/station-view/InvertersTable'
import Lines from "@/components/station-view/Lines";
import ProductionAndInsolation from "@/components/station-view/ProductionAndInsolation";

export default {
  name: "StationsView",
  components: {
    ProductionAndInsolation,
    PowerCalendar,
    Photo,
    PowerAndInsolation,
    InvertersRadar,
    PowerRate,
    Breadcrumbs,
    Lines
  },
  data() {
    return {
      polling: null
    };
  },
  methods: {
    loadData() {
      this.$store.dispatch("station/loadLastData", this.$route.params.id);
    }
  },
  mounted() {
    const id = this.$route.params.id;
    this.$store
      .dispatch("station/findOne", id)
      .then(() => this.$store.dispatch("station/loadLastData", id));
  },
  created() {
    this.polling = setInterval(this.loadData, 30 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  computed: {
    breadcrumbsData() {
      return [
        {
          title: this.station.title,
          url: "#"
        }
      ];
    },
    station() {
      return this.$store.getters["station/station"];
    },
    hasStation() {
      return this.$store.getters["station/hasStation"];
    },
    hasCamera() {
      // if (this.$store.getters[ 'station/station' ]) {
      //   return this.$store.getters[ 'station/station' ].schema.camera
      // }

      return false;
    }
  }
};
</script>
